import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { Helmet } from "react-helmet";
import ViewEvent from '../../components/viewEvent/viewEvent';
import AddIcon from '@mui/icons-material/Add';
import axiosInstance from "../../api/axiosInstance";
import moment from 'moment';
import "./list.scss"

const List = () => {
    const { selectedDate } = useOutletContext();

    const [events, setEvents] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [formModal, setFormModal] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState(null);

    const monday = useMemo(() => moment(selectedDate).startOf('isoWeek'), [selectedDate]);
    const sunday = useMemo(() => moment(selectedDate).endOf('isoWeek'), [selectedDate]);

    const fetchData = useCallback(async () => {
        try {
            const [eventsRes] = await Promise.all([
                axiosInstance.get(`events?start=${moment(monday).format("YYYY-MM-DD")}&end=${moment(sunday).format("YYYY-MM-DD")}`)
            ]);
            setEvents(eventsRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [monday, sunday]);

    useEffect(() => {
        fetchData();
        const intervalId = setInterval(fetchData, 30000);
        return () => clearInterval(intervalId);
    }, [fetchData]);

    const handleEventClick = (event) => {
        setFormModal(true);
        setSelectedEventId(event.id);
    };

    const handeleNewEvent = () => {
        setSelectedEventId(null);
        setFormModal(true);
    };

    return (
        <div className="list">
            <Helmet>
                <title>Auftragsliste</title>
            </Helmet>
            <button onClick={handeleNewEvent} className="new">
                <AddIcon />
            </button>
            {isLoading
                ? <div className="loading" />
                : < table >
                    <thead>
                        <tr>
                            <th>
                                <button>Kat.</button>
                            </th>
                            <th>
                                <button>Beschreibung</button>
                            </th>
                            <th>
                                <button>Auto</button>
                            </th>
                            <th>
                                <button>Mitarbeiter</button>
                            </th>
                            <th>
                                <button>Zeit</button>
                            </th>
                            <th>
                                <button>Kunde</button>
                            </th>
                            <th>
                                <button>Bestimmungsort</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event, eventIndex) => (
                            <tr key={eventIndex} onClick={() => handleEventClick(event)} className={`${event.done === 1 ? "done" : ""} ${selectedEventId === event.id ? "active" : ""}`}>
                                <td>
                                    <div className="status" style={{ background: event.statusColor + "1A" }}>
                                        <div className="dot" style={{ background: event.statusColor }} />
                                        <span style={{ color: event.statusColor }}>{event.statusName}</span>
                                    </div>
                                </td>
                                <td>{event.description}</td>
                                <td>{event.itemAlias}</td>
                                <td>{event.teamAlias}</td>
                                <td>
                                    {event.ganztags ? (
                                        event.startDate === event.endDate ? (
                                            moment(event.startDate).format("D. MMM")
                                        ) : (
                                            <span>
                                                {moment(event.startDate).format("D. MMM")} - {moment(event.endDate).format("D. MMM")}
                                            </span>
                                        )
                                    ) : (
                                        event.startDate === event.endDate ? (
                                            <span>
                                                {moment(event.startDate).format("D. MMM")}, {moment(event.startTime, "HH:mm:ss").format("H:mm")} Uhr - {moment(event.endTime, "HH:mm:ss").format("H:mm")} Uhr
                                            </span>
                                        ) : (
                                            <span>
                                                {moment(event.startDate).format("D. MMM")}, {moment(event.startTime, "HH:mm:ss").format("H:mm")} Uhr - {moment(event.endDate).format("D. MMM")}, {moment(event.endTime, "HH:mm:ss").format("H:mm")} Uhr
                                            </span>
                                        )
                                    )}
                                </td>
                                <td>{event.customer}</td>
                                <td>{event.loaction}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
            {
                formModal && (
                    <ViewEvent
                        selectedEventId={selectedEventId}
                        setFormModal={setFormModal}
                        setSelectedEventId={setSelectedEventId}
                        fetchData={fetchData}
                    />
                )
            }
        </div >
    )
};

export default List